import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selected, setSelected] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelected(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 text-foreground-600 text-xs font-semibold uppercase tracking-wider mb-4">
            Browse Categories
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Find Exactly What You Need
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Select a category below or use the dropdown to jump directly to our curated Kakobuy product databases.
          </p>
        </div>

        <div className="max-w-lg mx-auto mb-12">
          <div className="relative">
            <select
              value={selected}
              onChange={handleDropdownChange}
              className="w-full h-14 px-5 pr-12 rounded-full bg-background-50 border-2 border-background-200 text-foreground-800 text-sm font-medium appearance-none cursor-pointer focus:outline-none focus:border-primary-400 transition-colors"
            >
              <option value="">Select a Category...</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-5 top-1/2 -translate-y-1/2 text-foreground-500 text-lg pointer-events-none"></i>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-100 text-primary-800 text-sm font-medium hover:bg-primary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
              {cat.name}
              <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center ml-1"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}